var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraggableGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2.70423,
    rx: 1.35211,
    fill: "#AAAAAA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6.14844,
    width: 16,
    height: 2.70423,
    rx: 1.35211,
    fill: "#AAAAAA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 12.2949,
    width: 16,
    height: 2.70423,
    rx: 1.35211,
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableGrey);
export default __webpack_public_path__ + "static/media/draggable-grey.1322c4fce5deb3a2e2d3a7d7d9021651.svg";
export { ForwardRef as ReactComponent };